import {
  Box,
  Flex,
  Icon,
  Link,
  Stack,
  Text,
  useColorModeValue,
  VStack,
  Divider,
  Tooltip,
} from '@chakra-ui/react';
import React from 'react';
import { IconType } from 'react-icons';
import { FiBarChart2, FiHome, FiMonitor } from 'react-icons/fi';
import { useNavigate, useLocation } from 'react-router-dom';

interface NavItemProps {
  icon: IconType;
  label: string;
  path?: string;
  action?: () => void;
  isActive?: boolean;
}

const NavItem: React.FC<NavItemProps> = ({ icon, label, path, action, isActive }) => {
  const navigate = useNavigate();
  const bgActive = useColorModeValue('blue.500', 'blue.600');
  const colorActive = useColorModeValue('white', 'white');
  const bgHover = useColorModeValue('gray.700', 'gray.800');

  const handleClick = () => {
    if (action) {
      action();
    } else if (path) {
      navigate(path);
    }
  };

  return (
    <Tooltip label={label} placement="right" hasArrow>
      <Flex
        align="center"
        px={4}
        py={3}
        cursor="pointer"
        role="group"
        bg={isActive ? bgActive : 'transparent'}
        color={isActive ? colorActive : 'inherit'}
        borderRadius="lg"
        transition="all 0.2s"
        _hover={{
          bg: isActive ? bgActive : bgHover,
          transform: 'translateX(4px)',
        }}
        onClick={handleClick}
      >
        <Icon
          as={icon}
          boxSize={5}
          mr={3}
          _groupHover={{
            transform: 'scale(1.1)',
          }}
          transition="all 0.2s"
        />
        <Text fontSize="sm" fontWeight={isActive ? 'semibold' : 'medium'}>
          {label}
        </Text>
      </Flex>
    </Tooltip>
  );
};

const Sidebar: React.FC = () => {
  const location = useLocation();
  const bgColor = useColorModeValue('gray.800', 'gray.900');
  const textColor = useColorModeValue('white', 'gray.100');

  return (
    <Box
      as="nav"
      pos="fixed"
      left={0}
      top={0}
      h="full"
      w="240px"
      bg={bgColor}
      color={textColor}
      py={6}
      px={3}
      display={{ base: 'none', lg: 'block' }}
      zIndex={10}
    >
      <VStack align="stretch" spacing={1}>
        {/* Logo/Título */}
        <Flex align="center" px={4} mb={0} h="57px">
          <VStack align="start" spacing={0}>
            <Text fontSize="lg" fontWeight="bold" color="white">
              Painel Administrativo
            </Text>
          </VStack>
        </Flex>

        <Divider borderColor="gray.700" mb={4} />

        {/* Navegação Principal */}
        <Stack spacing={1}>
          <Text
            fontSize="xs"
            fontWeight="semibold"
            color="gray.400"
            px={4}
            mb={1}
            textTransform="uppercase"
          >
            Navegação
          </Text>

          <NavItem
            icon={FiHome}
            label="Dashboard"
            path="/admin"
            isActive={location.pathname === '/admin'}
          />

          <NavItem
            icon={FiBarChart2}
            label="Relatórios"
            path="/admin/relatorios"
            isActive={location.pathname === '/admin/relatorios'}
          />

          <NavItem
            icon={FiMonitor}
            label="Links dos terminais"
            path="/admin/terminais"
            isActive={location.pathname === '/admin/terminais'}
          />
        </Stack>

      </VStack>
    </Box>
  );
};

export default Sidebar;
